import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { InfoIcon } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface MarketPenetrationSectionProps {
  marketPenetration: string;
  setMarketPenetration: (value: string) => void;
  customerAcquisitionRate: string;
  setCustomerAcquisitionRate: (value: string) => void;
  penetrationStrategies: string[];
  setPenetrationStrategies: (value: string[]) => void;
}

export const MarketPenetrationSection = ({
  marketPenetration,
  setMarketPenetration,
  customerAcquisitionRate,
  setCustomerAcquisitionRate,
  penetrationStrategies,
  setPenetrationStrategies,
}: MarketPenetrationSectionProps) => {
  const strategyOptions = [
    "Marketing Campaigns",
    "Partnerships",
    "New Features",
    "Geographic Expansion"
  ];

  return (
    <div className="space-y-4">
      <div>
        <div className="flex items-center gap-2 mb-2">
          <Label>Market Penetration Percentage (3 years)</Label>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger>
                <InfoIcon className="h-4 w-4 text-gray-400" />
              </TooltipTrigger>
              <TooltipContent>
                <p className="max-w-xs">The estimated percentage of the total addressable market that your business expects to capture within the next 3 years through your growth strategies.</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
        <Input
          type="number"
          value={marketPenetration}
          onChange={(e) => setMarketPenetration(e.target.value)}
          placeholder="e.g., 5"
        />
      </div>

      <div>
        <Label>Customer Acquisition Rate (per year)</Label>
        <Input
          type="number"
          value={customerAcquisitionRate}
          onChange={(e) => setCustomerAcquisitionRate(e.target.value)}
          placeholder="e.g., 20000"
        />
      </div>

      <div>
        <Label>Penetration Strategies</Label>
        <div className="grid grid-cols-2 gap-2 mt-2">
          {strategyOptions.map((strategy) => (
            <div key={strategy} className="flex items-center space-x-2">
              <Checkbox
                checked={penetrationStrategies.includes(strategy)}
                onCheckedChange={(checked) => {
                  if (checked) {
                    setPenetrationStrategies([...penetrationStrategies, strategy]);
                  } else {
                    setPenetrationStrategies(
                      penetrationStrategies.filter((s) => s !== strategy)
                    );
                  }
                }}
              />
              <Label>{strategy}</Label>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};